// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function incidental_charge_type_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
    if (name.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                id: id._0,
                name: name._0
              }
            };
    }
    var e = name._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".name" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function tax_fare_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var tax_amount = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "tax_amount"), null));
  if (tax_amount.TAG === /* Ok */0) {
    var tax_name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "tax_name"), null));
    if (tax_name.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                tax_amount: tax_amount._0,
                tax_name: tax_name._0
              }
            };
    }
    var e = tax_name._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".tax_name" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = tax_amount._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".tax_amount" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function incidental_charge_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var charge_type = incidental_charge_type_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "charge_type"), null));
  if (charge_type.TAG === /* Ok */0) {
    var amount = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "amount"), null));
    if (amount.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                charge_type: charge_type._0,
                amount: amount._0
              }
            };
    }
    var e = amount._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".amount" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = charge_type._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".charge_type" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function state_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
    if (name.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                id: id._0,
                name: name._0
              }
            };
    }
    var e = name._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".name" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function order_fare_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var travel_duration = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "travel_duration"), null));
  if (travel_duration.TAG === /* Ok */0) {
    var travel_distance = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "travel_distance"), null));
    if (travel_distance.TAG === /* Ok */0) {
      var waiting_time = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "waiting_time"), null));
      if (waiting_time.TAG === /* Ok */0) {
        var total_restricted_time_mins = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "total_restricted_time_mins"), null));
        if (total_restricted_time_mins.TAG === /* Ok */0) {
          var toll = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "toll"), null));
          if (toll.TAG === /* Ok */0) {
            var road_tax = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "road_tax"), null));
            if (road_tax.TAG === /* Ok */0) {
              var convenience_charge = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "convenience_charge"), null));
              if (convenience_charge.TAG === /* Ok */0) {
                var environmental_tax = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "environmental_tax"), null));
                if (environmental_tax.TAG === /* Ok */0) {
                  var from_state = Decco.optionFromJson(state_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "from_state"), null));
                  if (from_state.TAG === /* Ok */0) {
                    var to_state = Decco.optionFromJson(state_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "to_state"), null));
                    if (to_state.TAG === /* Ok */0) {
                      var incidental_charges = Decco.listFromJson(incidental_charge_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "incidental_charges"), null));
                      if (incidental_charges.TAG === /* Ok */0) {
                        var fare_without_previous_due = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "fare_without_previous_due"), null));
                        if (fare_without_previous_due.TAG === /* Ok */0) {
                          var base_fare = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "base_fare"), null));
                          if (base_fare.TAG === /* Ok */0) {
                            var waiting_charge = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "waiting_charge"), null));
                            if (waiting_charge.TAG === /* Ok */0) {
                              var distance_charge = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "distance_charge"), null));
                              if (distance_charge.TAG === /* Ok */0) {
                                var flat_surge = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "flat_surge"), null));
                                if (flat_surge.TAG === /* Ok */0) {
                                  var travel_duration_charge = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "travel_duration_charge"), null));
                                  if (travel_duration_charge.TAG === /* Ok */0) {
                                    var total_taxes = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "total_taxes"), null));
                                    if (total_taxes.TAG === /* Ok */0) {
                                      var travel_fare = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "travel_fare"), null));
                                      if (travel_fare.TAG === /* Ok */0) {
                                        var subscription_discount = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "subscription_discount"), null));
                                        if (subscription_discount.TAG === /* Ok */0) {
                                          var premium_discount = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "premium_discount"), null));
                                          if (premium_discount.TAG === /* Ok */0) {
                                            var return_discount = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "return_discount"), null));
                                            if (return_discount.TAG === /* Ok */0) {
                                              var referral_discount = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "referral_discount"), null));
                                              if (referral_discount.TAG === /* Ok */0) {
                                                var coupon_discount = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "coupon_discount"), null));
                                                if (coupon_discount.TAG === /* Ok */0) {
                                                  var service_tax = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "service_tax"), null));
                                                  if (service_tax.TAG === /* Ok */0) {
                                                    var swachh_bharat_tax = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "swachh_bharat_tax"), null));
                                                    if (swachh_bharat_tax.TAG === /* Ok */0) {
                                                      var krishi_kalyan_tax = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "krishi_kalyan_tax"), null));
                                                      if (krishi_kalyan_tax.TAG === /* Ok */0) {
                                                        var pod_charge = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "pod_charge"), null));
                                                        if (pod_charge.TAG === /* Ok */0) {
                                                          var is_inter_state = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "is_inter_state"), null));
                                                          if (is_inter_state.TAG === /* Ok */0) {
                                                            var vat = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "vat"), null));
                                                            if (vat.TAG === /* Ok */0) {
                                                              var credit_charge = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "credit_charge"), null));
                                                              if (credit_charge.TAG === /* Ok */0) {
                                                                var fare = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "fare"), null));
                                                                if (fare.TAG === /* Ok */0) {
                                                                  var cash_back = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "cash_back"), null));
                                                                  if (cash_back.TAG === /* Ok */0) {
                                                                    var fare_after_cashback = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "fare_after_cashback"), null));
                                                                    if (fare_after_cashback.TAG === /* Ok */0) {
                                                                      var tax_fares = Decco.listFromJson(tax_fare_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "tax_fares"), null));
                                                                      if (tax_fares.TAG === /* Ok */0) {
                                                                        return {
                                                                                TAG: /* Ok */0,
                                                                                _0: {
                                                                                  travel_duration: travel_duration._0,
                                                                                  travel_distance: travel_distance._0,
                                                                                  waiting_time: waiting_time._0,
                                                                                  total_restricted_time_mins: total_restricted_time_mins._0,
                                                                                  toll: toll._0,
                                                                                  road_tax: road_tax._0,
                                                                                  convenience_charge: convenience_charge._0,
                                                                                  environmental_tax: environmental_tax._0,
                                                                                  from_state: from_state._0,
                                                                                  to_state: to_state._0,
                                                                                  incidental_charges: incidental_charges._0,
                                                                                  fare_without_previous_due: fare_without_previous_due._0,
                                                                                  base_fare: base_fare._0,
                                                                                  waiting_charge: waiting_charge._0,
                                                                                  distance_charge: distance_charge._0,
                                                                                  flat_surge: flat_surge._0,
                                                                                  travel_duration_charge: travel_duration_charge._0,
                                                                                  total_taxes: total_taxes._0,
                                                                                  travel_fare: travel_fare._0,
                                                                                  subscription_discount: subscription_discount._0,
                                                                                  premium_discount: premium_discount._0,
                                                                                  return_discount: return_discount._0,
                                                                                  referral_discount: referral_discount._0,
                                                                                  coupon_discount: coupon_discount._0,
                                                                                  service_tax: service_tax._0,
                                                                                  swachh_bharat_tax: swachh_bharat_tax._0,
                                                                                  krishi_kalyan_tax: krishi_kalyan_tax._0,
                                                                                  pod_charge: pod_charge._0,
                                                                                  is_inter_state: is_inter_state._0,
                                                                                  vat: vat._0,
                                                                                  credit_charge: credit_charge._0,
                                                                                  fare: fare._0,
                                                                                  cash_back: cash_back._0,
                                                                                  fare_after_cashback: fare_after_cashback._0,
                                                                                  tax_fares: tax_fares._0
                                                                                }
                                                                              };
                                                                      }
                                                                      var e = tax_fares._0;
                                                                      return {
                                                                              TAG: /* Error */1,
                                                                              _0: {
                                                                                path: ".tax_fares" + e.path,
                                                                                message: e.message,
                                                                                value: e.value
                                                                              }
                                                                            };
                                                                    }
                                                                    var e$1 = fare_after_cashback._0;
                                                                    return {
                                                                            TAG: /* Error */1,
                                                                            _0: {
                                                                              path: ".fare_after_cashback" + e$1.path,
                                                                              message: e$1.message,
                                                                              value: e$1.value
                                                                            }
                                                                          };
                                                                  }
                                                                  var e$2 = cash_back._0;
                                                                  return {
                                                                          TAG: /* Error */1,
                                                                          _0: {
                                                                            path: ".cash_back" + e$2.path,
                                                                            message: e$2.message,
                                                                            value: e$2.value
                                                                          }
                                                                        };
                                                                }
                                                                var e$3 = fare._0;
                                                                return {
                                                                        TAG: /* Error */1,
                                                                        _0: {
                                                                          path: ".fare" + e$3.path,
                                                                          message: e$3.message,
                                                                          value: e$3.value
                                                                        }
                                                                      };
                                                              }
                                                              var e$4 = credit_charge._0;
                                                              return {
                                                                      TAG: /* Error */1,
                                                                      _0: {
                                                                        path: ".credit_charge" + e$4.path,
                                                                        message: e$4.message,
                                                                        value: e$4.value
                                                                      }
                                                                    };
                                                            }
                                                            var e$5 = vat._0;
                                                            return {
                                                                    TAG: /* Error */1,
                                                                    _0: {
                                                                      path: ".vat" + e$5.path,
                                                                      message: e$5.message,
                                                                      value: e$5.value
                                                                    }
                                                                  };
                                                          }
                                                          var e$6 = is_inter_state._0;
                                                          return {
                                                                  TAG: /* Error */1,
                                                                  _0: {
                                                                    path: ".is_inter_state" + e$6.path,
                                                                    message: e$6.message,
                                                                    value: e$6.value
                                                                  }
                                                                };
                                                        }
                                                        var e$7 = pod_charge._0;
                                                        return {
                                                                TAG: /* Error */1,
                                                                _0: {
                                                                  path: ".pod_charge" + e$7.path,
                                                                  message: e$7.message,
                                                                  value: e$7.value
                                                                }
                                                              };
                                                      }
                                                      var e$8 = krishi_kalyan_tax._0;
                                                      return {
                                                              TAG: /* Error */1,
                                                              _0: {
                                                                path: ".krishi_kalyan_tax" + e$8.path,
                                                                message: e$8.message,
                                                                value: e$8.value
                                                              }
                                                            };
                                                    }
                                                    var e$9 = swachh_bharat_tax._0;
                                                    return {
                                                            TAG: /* Error */1,
                                                            _0: {
                                                              path: ".swachh_bharat_tax" + e$9.path,
                                                              message: e$9.message,
                                                              value: e$9.value
                                                            }
                                                          };
                                                  }
                                                  var e$10 = service_tax._0;
                                                  return {
                                                          TAG: /* Error */1,
                                                          _0: {
                                                            path: ".service_tax" + e$10.path,
                                                            message: e$10.message,
                                                            value: e$10.value
                                                          }
                                                        };
                                                }
                                                var e$11 = coupon_discount._0;
                                                return {
                                                        TAG: /* Error */1,
                                                        _0: {
                                                          path: ".coupon_discount" + e$11.path,
                                                          message: e$11.message,
                                                          value: e$11.value
                                                        }
                                                      };
                                              }
                                              var e$12 = referral_discount._0;
                                              return {
                                                      TAG: /* Error */1,
                                                      _0: {
                                                        path: ".referral_discount" + e$12.path,
                                                        message: e$12.message,
                                                        value: e$12.value
                                                      }
                                                    };
                                            }
                                            var e$13 = return_discount._0;
                                            return {
                                                    TAG: /* Error */1,
                                                    _0: {
                                                      path: ".return_discount" + e$13.path,
                                                      message: e$13.message,
                                                      value: e$13.value
                                                    }
                                                  };
                                          }
                                          var e$14 = premium_discount._0;
                                          return {
                                                  TAG: /* Error */1,
                                                  _0: {
                                                    path: ".premium_discount" + e$14.path,
                                                    message: e$14.message,
                                                    value: e$14.value
                                                  }
                                                };
                                        }
                                        var e$15 = subscription_discount._0;
                                        return {
                                                TAG: /* Error */1,
                                                _0: {
                                                  path: ".subscription_discount" + e$15.path,
                                                  message: e$15.message,
                                                  value: e$15.value
                                                }
                                              };
                                      }
                                      var e$16 = travel_fare._0;
                                      return {
                                              TAG: /* Error */1,
                                              _0: {
                                                path: ".travel_fare" + e$16.path,
                                                message: e$16.message,
                                                value: e$16.value
                                              }
                                            };
                                    }
                                    var e$17 = total_taxes._0;
                                    return {
                                            TAG: /* Error */1,
                                            _0: {
                                              path: ".total_taxes" + e$17.path,
                                              message: e$17.message,
                                              value: e$17.value
                                            }
                                          };
                                  }
                                  var e$18 = travel_duration_charge._0;
                                  return {
                                          TAG: /* Error */1,
                                          _0: {
                                            path: ".travel_duration_charge" + e$18.path,
                                            message: e$18.message,
                                            value: e$18.value
                                          }
                                        };
                                }
                                var e$19 = flat_surge._0;
                                return {
                                        TAG: /* Error */1,
                                        _0: {
                                          path: ".flat_surge" + e$19.path,
                                          message: e$19.message,
                                          value: e$19.value
                                        }
                                      };
                              }
                              var e$20 = distance_charge._0;
                              return {
                                      TAG: /* Error */1,
                                      _0: {
                                        path: ".distance_charge" + e$20.path,
                                        message: e$20.message,
                                        value: e$20.value
                                      }
                                    };
                            }
                            var e$21 = waiting_charge._0;
                            return {
                                    TAG: /* Error */1,
                                    _0: {
                                      path: ".waiting_charge" + e$21.path,
                                      message: e$21.message,
                                      value: e$21.value
                                    }
                                  };
                          }
                          var e$22 = base_fare._0;
                          return {
                                  TAG: /* Error */1,
                                  _0: {
                                    path: ".base_fare" + e$22.path,
                                    message: e$22.message,
                                    value: e$22.value
                                  }
                                };
                        }
                        var e$23 = fare_without_previous_due._0;
                        return {
                                TAG: /* Error */1,
                                _0: {
                                  path: ".fare_without_previous_due" + e$23.path,
                                  message: e$23.message,
                                  value: e$23.value
                                }
                              };
                      }
                      var e$24 = incidental_charges._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: ".incidental_charges" + e$24.path,
                                message: e$24.message,
                                value: e$24.value
                              }
                            };
                    }
                    var e$25 = to_state._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".to_state" + e$25.path,
                              message: e$25.message,
                              value: e$25.value
                            }
                          };
                  }
                  var e$26 = from_state._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".from_state" + e$26.path,
                            message: e$26.message,
                            value: e$26.value
                          }
                        };
                }
                var e$27 = environmental_tax._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".environmental_tax" + e$27.path,
                          message: e$27.message,
                          value: e$27.value
                        }
                      };
              }
              var e$28 = convenience_charge._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".convenience_charge" + e$28.path,
                        message: e$28.message,
                        value: e$28.value
                      }
                    };
            }
            var e$29 = road_tax._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".road_tax" + e$29.path,
                      message: e$29.message,
                      value: e$29.value
                    }
                  };
          }
          var e$30 = toll._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".toll" + e$30.path,
                    message: e$30.message,
                    value: e$30.value
                  }
                };
        }
        var e$31 = total_restricted_time_mins._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".total_restricted_time_mins" + e$31.path,
                  message: e$31.message,
                  value: e$31.value
                }
              };
      }
      var e$32 = waiting_time._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".waiting_time" + e$32.path,
                message: e$32.message,
                value: e$32.value
              }
            };
    }
    var e$33 = travel_distance._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".travel_distance" + e$33.path,
              message: e$33.message,
              value: e$33.value
            }
          };
  }
  var e$34 = travel_duration._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".travel_duration" + e$34.path,
            message: e$34.message,
            value: e$34.value
          }
        };
}

function order_and_fare_detail_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var crn = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "crn"), null));
  if (crn.TAG === /* Ok */0) {
    var status = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "status"), null));
    if (status.TAG === /* Ok */0) {
      var trip_accepted_time = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "trip_accepted_time"), null));
      if (trip_accepted_time.TAG === /* Ok */0) {
        var start_time = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "start_time"), null));
        if (start_time.TAG === /* Ok */0) {
          var pickup_time = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "pickup_time"), null));
          if (pickup_time.TAG === /* Ok */0) {
            var end_time = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "end_time"), null));
            if (end_time.TAG === /* Ok */0) {
              var order_type = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "order_type"), null));
              if (order_type.TAG === /* Ok */0) {
                var has_waypoints = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "has_waypoints"), null));
                if (has_waypoints.TAG === /* Ok */0) {
                  var has_fixed_strategy = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "has_fixed_strategy"), null));
                  if (has_fixed_strategy.TAG === /* Ok */0) {
                    var is_return_trip = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "is_return_trip"), null));
                    if (is_return_trip.TAG === /* Ok */0) {
                      var order_fare = order_fare_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "order_fare"), null));
                      if (order_fare.TAG === /* Ok */0) {
                        return {
                                TAG: /* Ok */0,
                                _0: {
                                  crn: crn._0,
                                  status: status._0,
                                  trip_accepted_time: trip_accepted_time._0,
                                  start_time: start_time._0,
                                  pickup_time: pickup_time._0,
                                  end_time: end_time._0,
                                  order_type: order_type._0,
                                  has_waypoints: has_waypoints._0,
                                  has_fixed_strategy: has_fixed_strategy._0,
                                  is_return_trip: is_return_trip._0,
                                  order_fare: order_fare._0
                                }
                              };
                      }
                      var e = order_fare._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: ".order_fare" + e.path,
                                message: e.message,
                                value: e.value
                              }
                            };
                    }
                    var e$1 = is_return_trip._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".is_return_trip" + e$1.path,
                              message: e$1.message,
                              value: e$1.value
                            }
                          };
                  }
                  var e$2 = has_fixed_strategy._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".has_fixed_strategy" + e$2.path,
                            message: e$2.message,
                            value: e$2.value
                          }
                        };
                }
                var e$3 = has_waypoints._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".has_waypoints" + e$3.path,
                          message: e$3.message,
                          value: e$3.value
                        }
                      };
              }
              var e$4 = order_type._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".order_type" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                      }
                    };
            }
            var e$5 = end_time._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".end_time" + e$5.path,
                      message: e$5.message,
                      value: e$5.value
                    }
                  };
          }
          var e$6 = pickup_time._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".pickup_time" + e$6.path,
                    message: e$6.message,
                    value: e$6.value
                  }
                };
        }
        var e$7 = start_time._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".start_time" + e$7.path,
                  message: e$7.message,
                  value: e$7.value
                }
              };
      }
      var e$8 = trip_accepted_time._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".trip_accepted_time" + e$8.path,
                message: e$8.message,
                value: e$8.value
              }
            };
    }
    var e$9 = status._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".status" + e$9.path,
              message: e$9.message,
              value: e$9.value
            }
          };
  }
  var e$10 = crn._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".crn" + e$10.path,
            message: e$10.message,
            value: e$10.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var data = order_and_fare_detail_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "data"), null));
  if (data.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              data: data._0
            }
          };
  }
  var e = data._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".data" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

export {
  incidental_charge_type_decode ,
  tax_fare_decode ,
  incidental_charge_decode ,
  state_decode ,
  order_fare_decode ,
  order_and_fare_detail_decode ,
  t_decode ,
  
}
/* No side effect */
